<template>
  <div class="we_chat">
    <div class="main">
      <div class="list">
        <div class="row" v-for="(inner, ind) in dataList" :key="ind">
          <div class="time">{{inner.printTime}}</div>
          <div class="m_flex_box" :class="inner.flow === 'out' ? 'flex_he' : ''">
            <div class="attr" :class="inner.flow === 'out' ? 'flex_2' : ''">
              <img :src="inner.flow === 'out' ? fromPic : toPic" />
            </div>
            <div v-if="inner.type === 'text'" class="text msg" :class="inner.flow === 'out' ? 'red' : ''" v-html="inner.text"></div>
            <div v-if="inner.type === 'image'" class="text msg" :class="inner.flow === 'out' ? 'red' : ''">
              <img :src="inner.file.url" />
            </div>
          </div>
        </div>
      </div>
      <div class="pad_top"></div>
      <div class="footer_con">
        <div class="footer m_flex_box flex_jz flex_vc">
          <div class="f_main m_flex_box flex_vc flex-1">
            <input class="flex-1" v-model="value" placeholder="" />
            <img src="@/assets/img/emoji.png" class="pic emoji_c" @click="showEmoji = true" alt="" ref="emojiCon">
            <transition>
              <div class="emoji_con emoji_c" v-show="showEmoji" ref="emojiCon">
                <VEmojiPicker @select="selectEmoji" />
              </div>
            </transition>
          </div>
          <img class="pic" v-show="value.trim() !== ''" src="@/assets/img/send.png" @click="send" />
          <label for="" class="label" v-show="value.trim() === ''">
            <input type="file" id="inpFile" @change="afterRead">
            <img class="pic" src="@/assets/img/picture.png" alt="">
          </label>
          <!-- <van-uploader id="inpFile" :before-read="beforeRead" :after-read="afterRead">
          </van-uploader> -->
        </div>
      </div>
    </div>
    <van-image-preview v-model="show" :images="[imgSrc]">
    </van-image-preview>
  </div>
</template>

<script>
const user = require('@/assets/img/tx.jpg');
const NIM = require('@/sdk/NIM_Web_NIM_v8.1.0.js')
import qs from 'qs';
import $ from 'jquery'
import topHeader from "@/components/header";
import VEmojiPicker from 'v-emoji-picker';
import { ImagePreview } from 'vant'
export default {
  data() {
    return {
      imgSrc: '',
      show: false,
      value: '',
      userImg: user,
      showEmoji: false,
      search: '',
      websock: null,
      timeout:10000,          //10s一次心跳检测
      nim: {},
      dataList: [],
      fromPic: user,
      toPic: user,
      title: '在线聊天'
    };
  },
  components: {
    VEmojiPicker: VEmojiPicker.VEmojiPicker,
    topHeader,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  created() {
    if(!localStorage.getItem('chatSession')) {
      localStorage.setItem('chatSession', true)
      window.location.reload()
    }
  },
  mounted() {
    this.to = this.$route.query.id;
    const that = this;
    $('body').on('click', '.msg img', function(){
      that.imgSrc = $(this).attr('src');
      that.show = true;
    })
    this.init();
  },
  methods: {
    init(){
      this.$toast.loading();
			var nim  = new NIM({
				// 初始化SDK
				// debug: true
				appKey: 'c732aec34adf5d0d2006eb0323edba12',
				account: this.$route.query.accid,
				token: this.$route.query.token,
				onconnect: this.onConnect,
				onerror: this.onError,
				onwillreconnect: this.onWillReconnect,
				ondisconnect: this.onDisconnect,
				// 多端
				onloginportschange: this.onLoginPortsChange,
				// 用户关系
				onblacklist: this.onBlacklist,
				onsyncmarkinblacklist: this.onMarkInBlacklist,
				onmutelist: this.onMutelist,
				onsyncmarkinmutelist: this.onMarkInMutelist,
				// 好友关系
				onfriends: this.onFriends,
				onsyncfriendaction: this.onSyncFriendAction,
				// 用户名片
				onmyinfo: this.onMyInfo,
				onupdatemyinfo: this.onUpdateMyInfo,
				onusers: this.onUsers,
				onupdateuser: this.onUpdateUser,
        // 会话
        syncSessionUnread: true,
				onupdatesession: this.onUpdateSession,
				// 消息
				onroamingmsgs: this.onRoamingMsgs,
				onofflinemsgs: this.onOfflineMsgs,
				onmsg: this.onMsg,
				// 系统通知
				onofflinesysmsgs: this.onOfflineSysMsgs,
				onsysmsg: this.onSysMsg,
				onupdatesysmsg: this.onUpdateSysMsg,
				onsysmsgunread: this.onSysMsgUnread,
				onupdatesysmsgunread: this.onUpdateSysMsgUnread,
				onofflinecustomsysmsgs: this.onOfflineCustomSysMsgs,
				oncustomsysmsg: this.onCustomSysMsg,
				// 同步完成
				onsyncdone: this.onSyncDone
			});
      this.nim = nim
      this.$forceUpdate();
    },
    onError(error, obj) {
      this.$toast.clear()
		},
    onConnect() {
      this.$toast.clear()
      console.log('连接成功');
      this.switchUserDialogue();
      this.nim.getUser({
          account: JSON.parse(localStorage.getItem('tokenObj')).accid,
          done: (error, user) => {
            this.fromPic = user.avatar ? user.avatar : this.userImg
          }
      });
      this.nim.getUser({
        account: this.$route.query.id,
          done: (error, user) => {
            console.log(user)
            this.title = user && user.nick || '在线聊天'
            this.toPic = user && user.avatar ? user.avatar : this.userImg
          }
      });
		},
		onWillReconnect(obj) {
		    // 此时说明 `SDK` 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
		    console.log('即将重连', obj);
		},
		onDisconnect(error) {
			// 此时说明 `SDK` 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
			console.log('连接断开', error);
			if (error) {
				switch (error.code) {
				// 账号或者密码错误, 请跳转到登录页面并提示错误
				case 302:
					this.loginError = true
					break;
				// 重复登录, 已经在其它端登录了, 请跳转到登录页面并提示错误
				case 417:
          this.$toast('您已在其他设备登录，请刷新后重试')
					break;
				// 被踢, 请提示错误后跳转到登录页面
				case 'kicked':
					break;
				default:
					break;
				}
			}
    },
		onUpdateSession(session) {
      console.log(session)
      if(session.lastMsg.flow == 'in' && session.lastMsg.from === this.$route.query.id) {
        this.$set(this.dataList, this.dataList.length, session.lastMsg)
        this.scrollBottom()
      }
      this.updateSessionsUI();
			this.$forceUpdate()
    },
    updateSessionsUI() {
		    // 刷新界面
		},
    scrollBottom(){
      this.$nextTick(()=> {
        if(this.dataList.length){
          var vs_char_view = document.getElementsByClassName('main')[0];
          document.documentElement.scrollTop = vs_char_view.scrollHeight;
          console.log(vs_char_view.scrollHeight)
        }
      })
		},
    switchUserDialogue(m){
			// this.nim.resetSessionUnread(m.id);
			this.nim.getHistoryMsgs({
			    scene: 'p2p',
			    to: this.to,
				  asc:true,
			    done: this.getHistoryMsgsDone
			});
		},
		getHistoryMsgsDone(error, obj) {			
      // console.log('获取云端历史记录' + (!error?'成功':'失败'), error, obj);
      if (!error) {
        this.dataList = obj.msgs;
        this.setMsgTime();
        this.scrollBottom();
      }
    },
     markSysMsgReadDone(error, obj) {
      console.log(error);
      console.log(obj);
      console.log('标记系统通知为已收到' + (!error?'成功':'失败'));
    },
    setMsgTime(){
			for(let i=0;i<this.dataList.length;i++){
				if(i === 0){
					this.dataList[i].printTime = this.formatTime(this.dataList[i].time)
				}else{
					if((this.dataList[i].time - 120000) > this.dataList[i-1].time){
						this.dataList[i].printTime = this.formatTime(this.dataList[i].time)
					}
				}
			}
		},
    send(){
      if(!this.value.trim()) {
        this.$toast('不能发送空白消息');
        return;
      }
			var msg = this.nim.sendText({
				scene: 'p2p',
				to: this.to,
        text: this.value,
        flow: 'out',
				done: this.sendMsgDone
			});
			this.value = ''
		},
    sendMsgDone(error, msg) {
			// console.log('发送' + msg.scene + ' ' + msg.type + '消息' + (!error?'成功':'失败') + ', id=' + msg.idClient, error, msg);
      if(!error) {
        this.dataList.push(msg);
        this.$toast.clear();
			  this.scrollBottom();
      }
		},
    formatTime(m){
			let time = new Date(m)
      var y = time.getFullYear();
      var m = time.getMonth()+1;
      var d = time.getDate();
			var hour = time.getHours() < 10 ? '0' + time.getHours() : time.getHours()
			var minute = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
			let now = y + m + d + ' ' + hour + ":" + minute
		},
    beforeRead(file) {
      if ((file.type).indexOf("image/") == -1) {
        this.$toast('请选择图片');
        return false;
      } else {
        return true;
      }
    },
    afterRead(file) {
      this.nim.sendFile({
        scene: 'p2p',
        to: this.to,
        type: 'image',
        fileInput: inpFile,
        uploadprogress: function(obj) {
        },
        uploaddone: (error, file) => {
            // console.log('上传' + (!error?'成功':'失败'), error, file);
            document.getElementById('inpFile').value = '';
        },
        beforesend: (msg) => {
          this.$toast.loading({
            forbidClick: true,
            message: '加载中...',
            duration: 0,
          });
        },
        done: this.sendMsgDone
			});
    },
    selectEmoji(emoji) {
      this.value = this.value + emoji.data
    },
  },
  beforeMount() {
      this._close = e => {
        if(e.target.className.indexOf('emoji_c') !== -1) {
          return;
        }
        this.showEmoji = false;
      };
      document.body.addEventListener('click', this._close);
  },
  beforeRouteLeave (to, from, next) {
    localStorage.removeItem('chatSession');
    next();
  },
  beforeDestroy() {
      document.body.removeEventListener('click', this._close);
  },
};
</script>
<style lang="less" scoped>
.we_chat{
  position: relative;
}
.list{
  padding: 0.40rem 0.30rem;
  box-sizing: border-box;
}
.row{
  margin-bottom: 0.40rem;
}
.msg{
  .list_tit{
    font-weight: 600;
    margin-bottom: 0.2rem;
  }
  ul{
    padding-left: 0.3rem;
  }
  li{
    padding: 0.2rem 0;
    list-style: disc;
    border-bottom: 1px solid #f2f2f2;
    color: #4887BD;
    &:last-child{
      border-bottom: none;
    }
  }
}
.time{
  font-size: 0.24rem;
  text-align: center;
  margin-bottom: 0.14rem;
  color: #666;
}
.attr{
  width: .80rem;
  height: .80rem;
  border-radius: 50%;
  overflow: hidden;
}
.attr img{
  width: 100%;
  height: 100%;
  display: block;
}
.text{
  max-width: 5.06rem;
  box-sizing: border-box;
  padding: 0.20rem;
  border-radius: 0.10rem;
  margin: 0 0.20rem;
  background-color: #fff;
  box-shadow: 0 0 0.06rem rgba(99,99,99,0.1);
  font-size: .26rem;
}
.text img{
  width: 2.50rem;
  height: 2.50rem;
}
.red{
  color: #fff;
  background-color: #E42C2C;
}
.footer{
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  background-color: #F3F3F3;
  padding: .30rem .38rem;
  box-sizing: border-box;
}
.f_main{
  background-color: #fff;
  border-radius: .40rem;
  height: .80rem;
  margin-right: .20rem;
  font-size: .24rem;
  box-sizing: border-box;
  padding: 0 .10rem 0 .30rem;
  input{
    font-size: 0.24rem;
  }
  .emoji_con{
    position: absolute;
    bottom: 1.4rem;
    left: 0;
  }
}
/deep/
#EmojiPicker{
  width: 100vw;
}
.pic{
  width: .52rem;
  height: .52rem;
}
.send{
  background-color: rgb(240, 111, 111);
  color: #fff;
  font-size: .24rem;
  height: .60rem;
  border-radius: .30rem;
  line-height: .60rem;
  padding: 0 .30rem;
}
.pad_top{
  padding-top: 1.40rem;
}
.top_con{
  box-sizing: border-box;
  height: 0.9rem;
  padding: 0 0.24rem;
  position: fixed;
  box-shadow: 0 0 0.1rem rgba(99,99,99,0.1);
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
}
.pad_t{
  padding-top: 0.9rem;
}
.label{
  position: relative;
  width: 0.52rem;
  height: 0.52rem;
}
#inpFile{
  opacity: 0;
  width: 0.52rem;
  height: 0.52rem;
  position: absolute;
  top: 0;
}
</style>